import React, { useState, useEffect } from 'react';
import { Route, Routes, Link } from 'react-router-dom';
import UploadPage from './pages/UploadPage';
import HistoryPage from './pages/HistoryPage';
import SettingsPage from './pages/SettingsPage';
import AboutPage from './pages/AboutPage';
import { GlobalProvider } from './GlobalContext'; // Import the provider

import './App.css';

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showIntro, setShowIntro] = useState(false); // Track intro visibility
  
  // Initialize dark mode based on user preference
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      setDarkMode(true);
    }
 
    // Check if intro should be shown
    const introDismissed = localStorage.getItem('introDismissed');
    if (!introDismissed) {
      setShowIntro(true);
      console.log('showing intro');
    }else{
      setShowIntro(false);
    }
  }, []);

  // Apply theme changes
  useEffect(() => {
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <GlobalProvider>
    <div className="app-container">
      <header>
        <div className="header-container">
          <div className="logo">
            <img src="/logo192.png" alt="Logo" />
          </div>
          <h1>Worthy</h1>
          {!showIntro && (
            <button className="hamburger-menu" onClick={toggleMenu}>
            ☰
            </button>
          )}
          
          {menuOpen && (
            <nav className="navigation-menu">
              <ul>
                <li><Link to="/" onClick={() => setMenuOpen(false)}>Upload</Link></li>
                <li><Link to="/history" onClick={() => setMenuOpen(false)}>History</Link></li>
                <li><Link to="/settings" onClick={() => setMenuOpen(false)}>Settings</Link></li>
                <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
              </ul>
            </nav>
          )}
        </div>
      </header>
      <Routes>
        <Route path="/" element={<UploadPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
      <footer>
        <div className="footer-container">
          <p>&copy; 2025 Worthy. All rights reserved.</p>          
        </div>       
        
      </footer>
    </div>
    </GlobalProvider>
  );
}

export default App;
